import { useState } from 'react'

export function DeepSeekSetupNotice() {
  const [isExpanded, setIsExpanded] = useState(false)
  const hasApiKey = !!import.meta.env.VITE_DEEPSEEK_API_KEY

  // Debug logging in development
  if (import.meta.env.DEV) {
    console.log('🔍 DeepSeekSetupNotice:')
    console.log('  - VITE_DEEPSEEK_API_KEY:', import.meta.env.VITE_DEEPSEEK_API_KEY ? '✅ Found' : '❌ Not found')
    console.log('  - hasApiKey:', hasApiKey)
    console.log('  - Component will:', hasApiKey ? 'hide (return null)' : 'show warning')
  }

  // Only show the notice when API key is missing
  if (hasApiKey) {
    return null
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <span className="text-yellow-600 mr-2">⚠️</span>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <span className="text-sm text-yellow-800 font-medium">
              DeepSeek API not configured - using fallback translations
            </span>
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-yellow-600 hover:text-yellow-800 text-sm underline"
            >
              {isExpanded ? 'Hide setup' : 'Show setup'}
            </button>
          </div>

          {isExpanded && (
            <div className="mt-3 text-sm text-yellow-700 space-y-2">
              <p className="font-medium">To enable real AI translations with DeepSeek:</p>
              <ol className="list-decimal list-inside space-y-1 ml-2">
                <li>Get your API key from <a href="https://platform.deepseek.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">platform.deepseek.com</a></li>
                <li>Create a <code className="bg-gray-100 px-1 rounded">.env</code> file in the admin package root</li>
                <li>Add: <code className="bg-gray-100 px-1 rounded">VITE_DEEPSEEK_API_KEY=your_api_key_here</code></li>
                <li>Restart the development server</li>
              </ol>
              <div className="bg-yellow-100 border border-yellow-300 rounded p-2 mt-2">
                <p className="text-xs text-yellow-800">
                  <strong>Note:</strong> Without the API key, translations will use fallback text with language indicators (e.g., "Health (French)").
                  This is sufficient for testing but not for production use.
                </p>
              </div>
              <button
                onClick={async () => {
                  console.log('🧪 Testing translation service...')
                  const { translationService } = await import('../services/translationService')
                  try {
                    const result = await translationService.translateCategory({
                      sourceLanguage: 'en',
                      targetLanguage: 'fr',
                      text: { name: 'Test Category', description: 'Test description' },
                      useJsonMode: true
                    })
                    console.log('✅ Translation test result:', result)
                    alert(`Translation test result: ${result.name}`)
                  } catch (error) {
                    console.error('❌ Translation test failed:', error)
                    alert(`Translation test failed: ${error}`)
                  }
                }}
                className="mt-3 px-3 py-1 bg-yellow-200 text-yellow-800 rounded text-xs hover:bg-yellow-300 transition-colors"
              >
                🧪 Test Translation
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 